import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { ROUTES } from './app.models';
import { createPermissionGuard } from './guards/permission.guard';
import { DeviceDetailsComponent } from './pages/device-details/device-details.component';
import { DeviceListComponent } from './pages/device-list/device-list.component';
import { ElsImportComponent } from './pages/els-import/els-import.component';
import { PropertyDetailsComponent } from './pages/property-details/property-details.component';
import { ProductViewComponent } from './pages/product-view/product-view.component';
import { PropertyListComponent } from './pages/property-list/property-list.component';
import { SettingsComponent } from './pages/settings/settings.component';
import { deviceDetailsGuard } from './guards/device-details.guard';
import { PermissionService } from './services/permission/permission.service';
import { BROWSER_TAB_SUFFIX } from './utils/utils';

export const routes: Routes = [
  {
    path: ROUTES.HOME,
    pathMatch: 'full',
    component: ProductViewComponent,
    data: { title: `Home${BROWSER_TAB_SUFFIX}` },
  },
  {
    path: ROUTES.PROPERTIES,
    pathMatch: 'full',
    component: PropertyListComponent,
    data: { title: `Property List${BROWSER_TAB_SUFFIX}` },
  },
  {
    path: ROUTES.DEVICES,
    pathMatch: 'full',
    component: DeviceListComponent,
    data: { title: `Device List${BROWSER_TAB_SUFFIX}` },
  },
  {
    path: ROUTES.DEVICE_DETAILS,
    pathMatch: 'full',
    component: DeviceDetailsComponent,
    canActivate: [deviceDetailsGuard],
  },
  {
    path: ROUTES.ELS_IMPORT,
    pathMatch: 'full',
    component: ElsImportComponent,
    canActivate: [createPermissionGuard(() => inject(PermissionService).canAccessElsImport$)],
    data: { title: `eLS Import${BROWSER_TAB_SUFFIX}` },
  },
  {
    path: ROUTES.PROPERTY_DETAILS,
    pathMatch: 'full',
    component: PropertyDetailsComponent,
    data: { title: `Property Details${BROWSER_TAB_SUFFIX}` },
  },
  { path: ROUTES.SETTINGS, pathMatch: 'full', component: SettingsComponent, data: { title: 'Settings' } },
  { path: '', pathMatch: 'full', redirectTo: ROUTES.HOME },
  { path: '**', redirectTo: ROUTES.HOME },
];
